import axios from 'axios';
import semver from 'semver';
import packjson from '../../package.json';
import { sm4 } from 'sm-crypto';

let util = {

};
util.title = function (title) {
    title = title || '席媒无纸化会议管理系统';
    window.document.title = title;
};


const ajaxUrl = "http://localhost:8082";

axios.defaults.baseURL = ajaxUrl;   //配置接口地址
axios.defaults.withCredentials=true;

util.ajax = axios.create({
    baseURL: ajaxUrl,
    timeout: 60000
});

/*
const ajaxUrl = env === 'development'
    ? 'http://127.0.0.1:8888'
    : env === 'production'
        ? 'https://www.url.com'
        : 'https://debug.url.com';

util.ajax = axios.create({
    baseURL: ajaxUrl,
    timeout: 30000
});*/

util.inOf = function (arr, targetArr) {
    let res = true;
    arr.forEach(item => {
        if (targetArr.indexOf(item) < 0) {
            res = false;
        }
    });
    return res;
};

util.oneOf = function (ele, targetArr) {
    if (targetArr.indexOf(ele) >= 0) {
        return true;
    } else {
        return false;
    }
};

util.showThisRoute = function (itAccess, currentAccess) {
    if (typeof itAccess === 'object' && Array.isArray(itAccess)) {
        return util.oneOf(currentAccess, itAccess);
    } else {
        return itAccess === currentAccess;
    }
};

util.getRouterObjByName = function (routers, name) {
    if (!name || !routers || !routers.length) {
        return null;
    }
    //
    let routerObj = null;
    for (let item of routers) {
        if (item.name === name) {
            return item;
        }
        routerObj = util.getRouterObjByName(item.children, name);
        if (routerObj) {
            return routerObj;
        }
    }
    return null;
};

util.handleTitle = function (vm, item) {
    if (typeof item.title === 'object') {
        return vm.$t(item.title.i18n);
    } else {
        return item.title;
    }
};

util.setCurrentPath = function (vm, name) {
    let title = '';
    let parentTitle = '';
    let parentPath = '';
    let parentName = '';
    let isOtherRouter = false;
    vm.$store.state.app.routers.forEach(item => {
        if (item.children.length === 1) {
            if (item.children[0].name === name) {
                title = util.handleTitle(vm, item);
                if (item.name === 'otherRouter') {
                    isOtherRouter = true;
                }
            }
        } else {
            item.children.forEach(child => {
                if (child.name === name) {
                    parentTitle = child.parentTitle;
                    parentPath = child.parentPath;
                    parentName = child.parentName;
                    title = util.handleTitle(vm, child);
                    if (item.name === 'otherRouter') {
                        isOtherRouter = true;
                    }
                }
            });
        }
    });
    let currentPathArr = [];
    if (name === 'home_index') {
        currentPathArr = [
            {
                title: util.handleTitle(vm, util.getRouterObjByName(vm.$store.state.app.routers, 'home_index')),
                path: '',
                name: 'home_index'
            }
        ];
    } else if ((name.indexOf('_index') >= 0 || isOtherRouter) && name !== 'home_index') {
        if(typeof parentTitle!="undefined"&&typeof parentPath!="undefined"&&typeof parentName!="undefined"){
        currentPathArr = [
            {
                title: util.handleTitle(vm, util.getRouterObjByName(vm.$store.state.app.routers, 'home_index')),
                path: '/home',
                name: 'home_index'
            },
            {
                title: parentTitle,
                path: parentPath,
                name: ""
            },
            {
                title: title,
                path: '',
                name: {
                    title: title,
                    path: '',
                    name: name
                }
            }
        ];
        }else{
            currentPathArr = [
                {
                    title: util.handleTitle(vm, util.getRouterObjByName(vm.$store.state.app.routers, 'home_index')),
                    path: '/home',
                    name: 'home_index'
                },
                {
                    title: title,
                    path: '',
                    name: {
                        title: title,
                        path: '',
                        name: name
                    }
                }
            ];
        }
    } else {
        let currentPathObj = vm.$store.state.app.routers.filter(item => {
            if (item.children.length <= 1) {
                return item.children[0].name === name;
            } else {
                let i = 0;
                let childArr = item.children;
                let len = childArr.length;
                while (i < len) {
                    if (childArr[i].name === name) {
                        return true;
                    }
                    i++;
                }
                return false;
            }
        })[0];
        if (currentPathObj.children.length <= 1 && currentPathObj.name === 'home') {
            currentPathArr = [
                {
                    title: '系统首页',
                    path: '',
                    name: 'home_index'
                }
            ];
        } else if (currentPathObj.children.length <= 1 && currentPathObj.name !== 'home') {
            currentPathArr = [
                {
                    title: '系统首页',
                    path: '/home',
                    name: 'home_index'
                },
                {
                    title: currentPathObj.title,
                    path: '',
                    name: name
                }
            ];
        } else {
            let childObj = currentPathObj.children.filter((child) => {
                return child.name === name;
            })[0];
            currentPathArr = [
                {
                    title: '系统首页',
                    path: '/home',
                    name: 'home_index'
                },
                {
                    title: currentPathObj.title,
                    path: '',
                    name: currentPathObj.name
                },
                {
                    title: childObj.title,
                    path: currentPathObj.path + '/' + childObj.path,
                    name: name
                }
            ];
        }
    }
    vm.$store.commit('setCurrentPath', currentPathArr);

    return currentPathArr;
};

util.openNewPage = function (vm, name, argu, query) {
    let pageOpenedList = vm.$store.state.app.pageOpenedList;
    let openedPageLen = pageOpenedList.length;
    let i = 0;
    let tagHasOpened = false;
    while (i < openedPageLen) {
        if (name === pageOpenedList[i].name) { // 页面已经打开
            vm.$store.commit('pageOpenedList', {
                index: i,
                argu: argu,
                query: query
            });
            tagHasOpened = true;
            break;
        }
        i++;
    }
    if (!tagHasOpened) {
        let tag = vm.$store.state.app.tagsList.filter((item) => {
            if (item.children) {
                return name === item.children[0].name;
            } else {
                return name === item.name;
            }
        });
        tag = tag[0];
        if (tag) {
            tag = tag.children ? tag.children[0] : tag;
            if (argu) {
                tag.argu = argu;
            }
            if (query) {
                tag.query = query;
            }
            vm.$store.commit('increateTag', tag);
        }
    }
    vm.$store.commit('setCurrentPageName', name);
};

util.toDefaultPage = function (routers, name, route, next) {
    let len = routers.length;
    let i = 0;
    let notHandle = true;
    while (i < len) {
        if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
            route.replace({
                name: routers[i].children[0].name
            });
            notHandle = false;
            next();
            break;
        }
        i++;
    }
    if (notHandle) {
        next();
    }
};

util.fullscreenEvent = function (vm) {
    vm.$store.commit('initCachepage');
    // 权限菜单过滤相关
    // vm.$store.commit('updateMenulist');
    // 全屏相关
};

util.checkUpdate = function (vm) {
    axios.get('https://api.github.com/repos/iview/iview-admin/releases/latest').then(res => {
        let version = res.data.tag_name;
        vm.$Notice.config({
            duration: 0
        });
        if (semver.lt(packjson.version, version)) {
            vm.$Notice.info({
                title: 'iview-admin更新啦',
                desc: '<p>iView-admin更新到了' + version + '了，去看看有哪些变化吧</p><a style="font-size:13px;" href="https://github.com/iview/iview-admin/releases" target="_blank">前往github查看</a>'
            });
        }
    });
};




util.post = function (url,params) {

    return axios.post(url, params);
};

util.login = function (params) {
    return axios.post("/login", params);
};

util.logout = function () {
    return axios.post("/logout");
};

util.setHeader = function (authCode) {


    util.ajax.defaults.headers.common['auth_code'] = authCode;



    // util.post("/user/info").then(function (res) {
    // });

};
/**
 * 判断日期相差几天  只能传yyyy-MM-dd格式
*/
util.deteInterval = function (date1, date2) {
  var startTime = Date.parse(new Date(date1));
  var endTime = Date.parse(new Date(date2));
  if ((endTime - startTime) / 1000 / 3600 / 24 + '' == 0) {
    return true
  } else {
    return false
  }
}

/**
 *
 * @param {目标数组} arr
 * @param {需要比较的数} num
 */
util.closest = (arr, num) => {
  var ret = arr[0];
  var distance = Math.abs(ret - num);
  for (var i = 1; i < arr.length; i++) {
    var newDistance = Math.abs(arr[i] - num);
    if (newDistance < distance) {
      distance = newDistance;
      if (arr[i] > num) {
        ret = i - 1;
      } else {
        ret = i;
      }
    }
  }
  return ret;
}

/**
  * 求出两个时间相差几分钟,计算必须是同一天的时间
  */
util.diffTime = (start, end) => {
  let openhh = parseInt(start.split(":")[0]);
  let openmm = parseInt(start.split(":")[1]);
  let closehh = parseInt(end.split(":")[0]);
  let closemm = parseInt(end.split(":")[1]);
  let hhDiff = closehh - openhh;
  let mmDiff = closemm - openmm;
  return hhDiff * 60 + mmDiff;
};

// 加密   secretKey为秘钥  message是需要加密后的字段
util.encryptByECB = (message, secretKey) => {
    message = JSON.stringify(message)
    let cipherText = sm4.encrypt(message, secretKey, 'ecb');
    cipherText = { data: cipherText }
    return cipherText
};
  
// 解密   secretKey为秘钥  ciphertext是加密后的字段
util.decryptByECB = (ciphertext, secretKey) => {

    let decryptedData = sm4.decrypt(ciphertext, secretKey, 'ecb');
    decryptedData = JSON.parse(decryptedData);
    return decryptedData
};

util.debounce = (fn, delay) => {
	var time = null
	return function() {
		let context = this;//记录一下this指向
		let args = arguments;
		//清除定时任务
		if (time) clearTimeout(time);
		time = setTimeout(function() {
			time = null;
			fn.apply(context, args)
		}, delay)
	}
}

export default util;



// WEBPACK FOOTER //
// ./src/libs/util.js